export default "__VITE_PUBLIC_ASSET__028f2d9b__"